import { useRedux, useBackButtonClose } from "hooks";
import React, { forwardRef, useCallback, useEffect, useRef, useState } from "react";
import { createSelector } from "reselect";
import WorkplaceHead from "./WorkplaceHead";
import WorkplaceInput from "./WorkplaceInput";
import AppSimpleBar from "components/AppSimpleBar";
import WorkplaceQuill from "components/WorkplaceQuill";
import { LogDb, Utils } from "helpers/utils";
import Loader from "components/Loader";
import { TaskStatus, WpConver, WpEmoji, WpPostType, WpSliceData, WpStatus, PostCommands } from "../../../redux/workplace/wpTypes";
import { togglePostEmoji, setSnooze, setActivePostId2, loadMorePostConver } from "../../../redux/workplace/wpActions";
import { changeSelectedChat } from "../../../redux/actions";
import classnames from "classnames";
import UserAvatar from "components/UserAvatar";
import { updateReadApi } from "../../../api/wpapi";
import { APIClient } from "../../../api/apiCore";
import * as urls from "../../../api/urls";


import { Const } from "const";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Util } from "reactstrap";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import DatePicker from "react-datepicker";
import LoadingIconWithText from "components/LoadingIconWithText";
import WorkplaceCollectionModal from "./WorkplaceCollectionModal";
import { useNavigate } from "react-router-dom";
import { DbUtils } from "helpers/dbUtils";
import { WpModes } from "../../../constants";
import WorkplaceHeadTask from "./WorkplaceHeadTask";
import TaskFormField from "./TaskFormField";
import PostCommand from "./PostCommand";
import ExcelPreviewModal from "./ExcelPreviewModal";


interface WorkplaceContentProps {
  wpMode: WpModes,
  instantMode: boolean,
}
const WorkplaceContent = ({ wpMode, instantMode }: WorkplaceContentProps) => {
  // console.log('WorkplaceContent: wpMode = ' + wpMode);
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (state: any) => state.Profile2,
    (state: any) => state.Layout,
    (wp: WpSliceData, p2, layout) => ({

      // activePostId: wpMode == WpModes.Workplace ? wp.activePostInfo.postId : wp.activeTaskInfo.postId,
      // activePostStatus: wpMode == WpModes.Workplace ? wp.activePostInfo.status : wp.activeTaskInfo.status,
      // activePostStatusById: wpMode == WpModes.Workplace ? wp.activePostInfo.statusById : wp.activeTaskInfo.statusById,
      // activePostStatusDate: wpMode == WpModes.Workplace ? wp.activePostInfo.statusDate : wp.activeTaskInfo.statusDate,
      // activePostStatusRemark: wpMode == WpModes.Workplace ? wp.activePostInfo.statusRemark : wp.activeTaskInfo.statusRemark,
      // activePostStatusByName: wpMode == WpModes.Workplace ? wp.activePostInfo.statusByName : wp.activeTaskInfo.statusByName,
      // activePostYouIsMember: wpMode == WpModes.Workplace ? (wp.activePostInfo.youIsMember || wp.activePostInfo.isYourPost) : (wp.activeTaskInfo.youIsMember || wp.activeTaskInfo.isYourPost),

      activePostId: wp.activePostInfo.postId,
      activePostStatus: wp.activePostInfo.status,
      activePostStatusById: wp.activePostInfo.statusById,
      activePostStatusDate: wp.activePostInfo.statusDate,
      activePostStatusRemark: wp.activePostInfo.statusRemark,
      activePostStatusByName: wp.activePostInfo.statusByName,
      activePostYouIsMember: (wp.activePostInfo.youIsMember || wp.activePostInfo.isYourPost),
      activePostInfoLoading: wp.activePostInfoLoading,
      activePostPlanFinishedDate: wp.activePostInfo.planFinishedDate,
      activePostMode: wp.activePostInfo.wpMode,
      activePostTitle: wp.activePostInfo.title,
      activePostAbbrName: wp.activePostInfo.abbrName,
      activePostAbbrFore: wp.activePostInfo.abbrFore,
      activePostAbbrBack: wp.activePostInfo.abbrBack,
      createSubTaskFromTaskId: wp.createSubTaskFromTaskId,


      converLoading: wp.converLoading,
      converErrMsg: wp.converErrMsg,
      convers: wp.convers,
      converLoadingMore: wp.converLoadingMore,
      converHasMore: wp.converHasMore,

      curUserId: p2.userId,
      layoutMode: layout.layoutMode,
      viewPortWidth: layout.viewPortWidth,
      postTitles: wpMode == WpModes.Workplace ? wp.titles : wp.titlesTk,

      taskStatus: wp.activePostInfo.taskStatus ?? TaskStatus.ToDo,
    })
  );
  // Inside your component
  const {
    activePostId, createSubTaskFromTaskId, converLoading, converErrMsg, convers, converLoadingMore, converHasMore, curUserId
    , activePostStatus, activePostStatusDate, activePostStatusRemark, activePostStatusByName
    , activePostYouIsMember, activePostMode
    , activePostTitle, activePostAbbrName, activePostAbbrFore, activePostAbbrBack
    , layoutMode
    , postTitles
    , taskStatus
    , activePostInfoLoading
    , viewPortWidth
    , activePostPlanFinishedDate
  } = useAppSelector(storeData);

  const isDarkMode = layoutMode === "dark";
  const activePostIdRef = useRef(activePostId);
  useEffect(() => { activePostIdRef.current = activePostId }, [activePostId]);

  const onRetryLoadConver = () => {
    if (activePostId) {
      dispatch(setActivePostId2(wpMode, activePostId, activePostTitle, activePostAbbrName, activePostAbbrFore, activePostAbbrBack, "retry"));
    }
  }

  useEffect(() => {
    // console.log('activePostYouIsMember = ' + activePostYouIsMember);
  }, [activePostYouIsMember]);

  // const INPUT_TOPPER_HEIGHT = wpMode == WpModes.Workplace ? 0 : 200; /* Workplace Task*/
  const INPUT_SMALL_HEIGHT = 160;
  const INPUT_TOOLBAR_HEIGHT = 90;// + INPUT_TOPPER_HEIGHT;
  const INPUT_LARGE_HEIGHT = 600;

  interface TaskUpdateState {
    planFinishedDate: Date | null,
    taskStatus: TaskStatus | null,
    remark: string,
    // opened by clicking the date in the header: calendar only, no status change, no remark
    isDateOnly: boolean
  }

  const [inputPanelHeight, setInputPanelHeight] = useState<number>(INPUT_SMALL_HEIGHT);
  const [inputEditorHeight, setInputEditorHeight] = useState<number>(INPUT_SMALL_HEIGHT - INPUT_TOOLBAR_HEIGHT);
  const [isLageEditor, setIsLageEditor] = useState<boolean>(false);
  const [isEmojiRespShow, setIsEmojiRespShow] = useState<boolean>(false);
  const [showUnsendMenu, setShowUnsendMenu] = useState<boolean>(false);
  const [emojiRespPos, setEmojiRespPos] = useState<any>({ left: 0, top: 0 });
  const [showTaskStatusMenu, setShowTaskStatusMenu] = useState<boolean>(false);
  const [showPlanFinishedDate, setShowPlanFinishedDate] = useState<boolean>(false);
  const [taskUpdateState, setTaskUpdateState] = useState<TaskUpdateState>();
  const [taskStatusRemarkError, setTaskStatusRemarkError] = useState<string | null>(null);
  const [showPostContextMenu, setShowPostContextMenu] = useState<boolean>(false);
  const refScroll = useRef<any>();
  const isPrependingConverRef = useRef<boolean>(false);
  const prevScrollHeightRef = useRef<number>(0);

  const emojis = [
    { name: 'OK', icon: '🆗' },
    { name: 'Smile', icon: '😊' },
    { name: 'Cry', icon: '😢' },
    { name: 'Crying Smile', icon: '😂' },

    { name: 'Good', icon: '👍' },
    { name: 'Thank you', icon: '🙏' },
    { name: 'Strong', icon: '💪' },
    { name: 'Crab', icon: '👏' },

    { name: 'Done', icon: '✅' },
    { name: 'No', icon: '❌' },
    { name: 'Smile Glasses', icon: '😎' },
    { name: 'Ok Hand', icon: '👌' },

    // { name: 'Plus 1', icon: '➕' },
    // { name: 'Minus 1', icon: '➖' },

    { name: '100%', icon: '💯' },
    { name: 'Love', icon: '❤️' },
    // { name: 'Negative', icon: '🆖' }, //{ name: 'Wait', icon: '⌛' },
    { name: 'Delivery', icon: '🚚' },
    { name: 'Soon', icon: '🔜' },

    { name: 'Plus', icon: '➕' },
    // { name: 'Minus 1', icon: '➖' },
    { name: 'GoodLove', icon: '🫰🏻' },
    { name: 'Ack', icon: '🫡 ' },
    { name: 'OMG', icon: '😱' },

  ];

  const onLargeStageClick = () => {
    setIsLageEditor((prev) => !prev);
  }
  useEffect(() => {
    const panelHeight = (isLageEditor ? INPUT_LARGE_HEIGHT : INPUT_SMALL_HEIGHT);
    setInputPanelHeight(panelHeight);
    setInputEditorHeight(panelHeight - INPUT_TOOLBAR_HEIGHT);
  }, [isLageEditor]);

  useEffect(() => {
    if (activePostId == "" || createSubTaskFromTaskId) { // new post
      setIsLageEditor(true);
    } else if (isLageEditor) {
      setIsLageEditor(false);
    }
  }, [activePostId, createSubTaskFromTaskId]);

  // const [onSaving, setOnSaving] = useState<boolean>(false);
  // const onSave = async (text: string, html: string, blobUploads: QuillFileUpload[]) => {
  //   try {
  //     setOnSaving(true);
  //     console.log({ text, html, blobUploads });
  //     setOnSaving(false);
  //   } catch (e) {
  //     Utils.HandleException(e);
  //     setOnSaving(false);
  //   }
  // }
  const isForwarded = false;
  const isDark = Utils.IsDarkTheme();

  let newTab: Window | null = null;
  // Function to open a URL in a new tab and reuse the same tab for subsequent calls
  function openUrlInSameTab(url: string): void {
    const tabName = "myUniqueTabName"; // Unique name for the tab
    if (!newTab || newTab.closed) {
      // If the tab doesn't exist or is closed, open a new one
      newTab = window.open(url, tabName);
    } else {
      // If the tab is already open, update its location
      newTab.location.href = url;
      newTab.focus();
    }
  }

  useEffect(() => {
    // Function to handle click event
    const handleAClick = (event: Event) => {
      const target = event.target as HTMLElement;
      if (target.tagName === "A" || target.tagName === "IMG") {
        const atype = target.getAttribute("atype");
        // console.log('atype = ' + atype);
        if (atype === "image" || atype === "tag") {
          event.preventDefault(); // Prevent default navigation (if needed)
          if (atype === "image") {
            const img = target as HTMLImageElement

            /* 20250729 make it preview by prev/next
            //const url = img.src.replaceAll("thumb_/", "");
            // Remove 'thumb_/' from the URL
            let cleanedUrl = img.src.replace('thumb_/', '');

            // Insert 'https://domain2.com' before '/_uploadwp'
            const uploadIndex = cleanedUrl.indexOf('/_uploadwp');
            // console.log('uploadIndex = ' + uploadIndex);
            if (uploadIndex !== -1) {
              const prUrl = process.env.REACT_APP_URL_FOR_STATIC;
              if (prUrl) {
                cleanedUrl = prUrl + cleanedUrl.substring(uploadIndex);
              }
            }
            console.log('cleanedUrl:' + cleanedUrl);

            openUrlInSameTab(cleanedUrl);
            */
            onPreviewImage(img.id);
          } else if (atype === "tag") {
            const tagId = Utils.ToNumber(target.getAttribute("aval"), -1) ?? -1;
            onTagClick(tagId);
          } else {
            alert('Click ' + atype);
          }

          // console.log(`Clicked on a link with atype="${atype}"`);
          // Perform your logic here
          //} else if (atype === "file") {
        } else if (atype === "file") {
          const lnk = target as HTMLLinkElement;
          let href = lnk.href;
          const isExcel = href.toLocaleLowerCase().includes(".xls") || href.toLocaleLowerCase().includes(".xlsx");
          if (Utils.IsIOS() && isExcel) {
            // donothing, use default behavior
          } else {
            event.preventDefault();
            new LogDb().Write(`Click tag file ${href}`);
            const w = 1200, h = 800;
            const left = Math.max(0, (window.screen.width - w) / 2);
            const top = Math.max(0, (window.screen.height - h) / 2);
            window.open(href, 'wpFilePreview', `width=${w},height=${h},top=${top},left=${left},resizable=yes,scrollbars=yes`);
          }
        }

      }
    };

    // Attach event listener to the document (event delegation)
    // capture:true fires before browser native link handling (prevents iOS WKWebView
    // from opening target="_blank" file links in a new window before JS can intercept)
    document.addEventListener("click", handleAClick, true);

    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener("click", handleAClick, true);
    };
  }, []);

  // const lastMessageRef = useRef<HTMLLIElement | null>(null);
  // const lastMessageRef = useRef<HTMLDivElement | null>(null);
  const [firstTimeScroll, setFirstTimeScroll] = useState<boolean>(true);
  const [lastConverCount, setLastConverCount] = useState<number>(0);
  const [haveNewText, setHaveNewText] = useState<string | null>(null);
  const firstUnreadIndex = (convers || []).findIndex((m: WpConver) => !m.isRead);
  useEffect(() => {
    if (isPrependingConverRef.current) {
      // older conversation prepended from scroll-up load-more: keep the currently visible content
      // in place instead of running the normal auto-scroll/unread logic below
      isPrependingConverRef.current = false;
      const scrollableNode = refScroll.current?.getScrollElement();
      if (scrollableNode) {
        const addedHeight = scrollableNode.scrollHeight - prevScrollHeightRef.current;
        scrollableNode.scrollTop = scrollableNode.scrollTop + addedHeight;
      }
      return;
    }
    const divConverContainer = document.getElementById('divConverContainer');
    const scrollToIndex = firstUnreadIndex >= 0 ? firstUnreadIndex : ((divConverContainer?.children?.length ?? 0) - 1);
    // console.log('scroll to index = ' + scrollToIndex + ' of total count = ' + (divConverContainer?.children?.length ?? 0));
    if (scrollToIndex >= 0) {
      const backButton = document.getElementById("back-button-wp") as HTMLButtonElement | null;
      let isUserReading = false;
      if (firstTimeScroll == false && backButton != null && backButton.classList.contains("show") && convers[convers.length - 1].postById != curUserId) {
        isUserReading = true;
      }
      // console.log({ firstTimeScroll, scrollToIndex, firstUnreadIndex, isUserReading });
      // console.log('convers.length = ' + convers.length, convers[0]);
      if (!isUserReading) {
        const listItem = divConverContainer?.children[scrollToIndex] as HTMLElement;
        const toBottom = scrollToIndex == ((divConverContainer?.children?.length ?? 0) - 1);
        // console.log(listItem);
        if (toBottom) {
          //refScroll.current.scrollTop = refScroll.current?.scrollHeight;
          // console.log('scroll to bottom');
          listItem?.scrollIntoView({ behavior: firstTimeScroll ? "instant" : "smooth", block: "start" });
        } else {
          listItem?.scrollIntoView({ behavior: firstTimeScroll ? "instant" : "smooth", block: "center" });
        }
        setLastConverCount(convers.length);
      } else { // user is reading
        if (lastConverCount != convers.length) { // have new text
          setHaveNewText(convers[convers.length - 1].postByName);
        }
      }
    }
    setFirstTimeScroll(false);
    showBackButton();
    let updateRead = firstUnreadIndex >= 0 && activePostId;
    if (!updateRead) {
      const selectedTitle = postTitles.filter(x => x.postId === activePostId);
      if (selectedTitle && selectedTitle.length > 0) updateRead = selectedTitle[0].unread > 0 ? "1" : null;
    }

    if (updateRead/*firstUnreadIndex >= 0 && activePostId*/) { // have unread item
      try {
        // console.log('conver change then update read on : ' + activePostId);
        fnUpdateUnread(activePostId ?? "");

        // const rs = updateReadApi(activePostId);
        // console.log('updateReadApi:', rs);
      } catch (e) {
        Utils.HandleException(e, false);
      }
    }
  }, [convers]);

  useEffect(() => {
    // covers the load-more error path, where `convers` never changes so the effect above never runs
    if (!converLoadingMore) isPrependingConverRef.current = false;
  }, [converLoadingMore]);

  useEffect(() => {
    // 20250925 save in local
    // don't persist a failed load's empty result — it would poison the local cache for next time
    if (converErrMsg) return;
    // SET_ACTIVE_POSTID2 resets convers to [] with converLoading=true; saving then would overwrite this post's cache with an empty list
    if (converLoading) return;
    try {
      if (activePostId != null && activePostId != "") {
        // console.log('save post conver to mem ' + activePostId, {convers});
        // key must match the read side in setActivePostIdSaga (wlpc_ for Workplace, tkpc_ for Task)
        if ((activePostMode ?? wpMode) == WpModes.Task) {
          DbUtils.wp_load_task_conver(activePostId, convers);
        } else {
          DbUtils.wp_load_post_conver(activePostId, convers);
        }
      }
    } catch (e2) {
      Utils.HandleException(e2, false);
    }
  }, [activePostId, activePostMode, convers, converErrMsg, converLoading]);

  const fnUpdateUnread = async (postId: string) => {
    try {
      const rs = await updateReadApi(postId);
      const snooze = rs?.snooze ? true : false;
      dispatch(setSnooze(wpMode, postId, snooze));
      // console.log('updateReadApi:', rs);
    } catch (e) {
      const msg = Utils.GetMessageFromExecption(e);
      console.error(msg);
      if (msg.includes("Object reference not set to an instance of an object")) {
        Utils.HandleException(e, false);
      } else {
        Utils.HandleException(e, true);
      }

    }
  }

  useEffect(() => {
    setFirstTimeScroll(true);
  }, [activePostId]);

  useEffect(() => {
    if (converLoading) {
      setFirstTimeScroll(true);
    }
  }, [converLoading]);

  interface ContentProps { conv: WpConver, index: number }

  // แสดง icon + ชื่อ + เวลา และแถวล่างเป็น content
  const ContentV1: React.FC<ContentProps> = ({ conv }) => {
    return (
      <>
        <div className="d-flex align-items-center mb-1 ms-1" style={{ position: "relative" }}>
          <div className={classnames("chat-user-img", "align-self-center", "me-2", "ms-0",)}>
            <UserAvatar profileImage={conv.pictureUrl ?? ""} bgColor={conv.bgColor ?? ""} foreColor={conv.foreColor ?? ""} abbrName={conv.abbrName ?? ""} size={"xs"} includeDivContainer={true} />
          </div>
          <div className="overflow-hidden">
            <p className="text-truncate mb-0">
              {conv.postByName}
            </p>
            <p className="text-truncate mb-0 last-chat-text" style={{ lineHeight: "13px" }}>
              {Utils.GetShortDateTimeToShowInChat(conv.postDateTime, true)}
            </p>
          </div>
          <div className="ms-auto text-end">
            ...
          </div>
          <i className="fas fa-sort-up icon-caret"></i>
        </div>
        <div className={classnames("wp-conver-content" + (instantMode ? "-inst" : ""), { "mine": conv.isFromMe })} dangerouslySetInnerHTML={{ __html: conv.bodyHtml ?? "" }}>
        </div>
      </>
    );
  }

  const formatQuillContent = (content: string) => {
    return content.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;'); // Replace tab with 4 spaces
  };

  const viewPostMember = async (postId: string) => {
    const api = new APIClient;
    api.fnPostForm(urls.WP_GET_POST_MEM_READ, { postId: postId })
      .then(rs => {
        var html = `<table width="100%" border="0">`;
        rs.forEach((mem: any) => {
          const iconClass = mem.isRead ? "text-primary" : "text-secondary";
          html += `<tr class="${mem.isActive ? "" : "user-inactive"}">`;
          html += `<td align="left">${mem.displayName2}</td>`;
          html += `<td align="left"><i class="fas fa-eye ${iconClass}"></i>&nbsp;${mem.isRead ? Utils.GetShortDateTimeToShowInChat(mem.readDateTime, false) : ""}</td>`;
          html += `</tr>`;
        });
        html += `</table>`;
        alert(html);
      })
      .catch(e => Utils.HandleException(e, true));
  }

  const onCopyPostConent = async (postId: string) => {
    try {
      const div = document.getElementById(`divWpContent-${postId}`);
      if (div) {
        const paragraphs = Array.from(div.querySelectorAll("p"));
        const lines = paragraphs.map(p => {
          const text = p.textContent?.trim();
          return text === "" ? "" : text; // Preserve empty <p> as blank line
        });

        // Combine all lines with single newlines — blank lines are preserved as empty strings
        const textToCopy = lines.join("\n");
        await navigator.clipboard.writeText(textToCopy);
      }
      // console.log(postId);
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const [toolPostInfo, setToolPostInfo] = useState<any>({});

  const onShowRespEmojiPlate = (target: HTMLElement/*event: React.MouseEvent<HTMLElement>*/) => {
    triggerRef.current = target;// event.currentTarget;
    // Get the position of the clicked icon relative to the viewport
    const iconRect = target/*event.currentTarget*/.getBoundingClientRect();
    const containerRect = document.getElementById("workplace-container")?.getBoundingClientRect();
    if (!containerRect) return;

    const toolInfo = {
      postId: target.getAttribute('data-postid'),
      postIdParent: target.getAttribute('data-postidparent'),
      isFromMe: Utils.ToBool(target.getAttribute('data-isfromme'), false),
    };
    const dataShowUnsend = (target.getAttribute('data-show-unsend') == "1");
    setToolPostInfo(toolInfo);

    // Calculate position relative to container, accounting for scroll
    // const scrollLeft = containerRef.current.scrollLeft;
    const scrollTop = (containerRect as any).scrollTop ?? 0;
    const scrollLeft = (containerRect as any).scrollLeft ?? 0;

    // Estimated popup size (or use a ref to measure if dynamic)
    const popupWidth = 150;
    const popupHeight = 210;//190;

    // Available space around the icon
    const spaceBelow = window.innerHeight - iconRect.bottom;
    const spaceAbove = iconRect.top;
    const spaceRight = window.innerWidth - iconRect.right;
    const spaceLeft = iconRect.left;

    // Decide vertical position (top)
    let top;
    if (spaceBelow < popupHeight && spaceAbove >= popupHeight) {
      // Show above
      top = iconRect.top - containerRect.top + scrollTop - popupHeight;
    } else {
      // Show below
      top = iconRect.top - containerRect.top + scrollTop + iconRect.height;
    }

    // Decide horizontal position (left)
    let left;
    if (spaceRight < popupWidth && spaceLeft >= popupWidth) {
      // Show left-aligned if not enough space to the right
      left = iconRect.right - containerRect.left - popupWidth;
    } else {
      // Show right-aligned (default)
      left = iconRect.left - containerRect.left;
    }

    // console.log('top,lef:',{top, left, bottom:top+popup});

    setEmojiRespPos({
      top: top,
      left: left
    });

    // console.log('toggle emoji pane');
    setShowUnsendMenu(dataShowUnsend);
    setIsEmojiRespShow(true);//prev => !prev);
  }

  const popupRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!isEmojiRespShow) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      const dataEmoji = (target as any).getAttribute('data-emoji');
      if (dataEmoji == "1") { // click on emoji icon
        onShowRespEmojiPlate(target as HTMLElement);//event as unknown as React.MouseEvent<HTMLElement>);
      } else {
        if (
          popupRef.current &&
          !popupRef.current.contains(target) &&
          triggerRef.current &&
          !triggerRef.current.contains(target)
        ) {
          // console.log('hide emoji from click outside');
          setIsEmojiRespShow(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEmojiRespShow]);

  const test = async () => {
    dispatch(togglePostEmoji('588f80c4-2344-421f-8c0e-162b36de1f17', 'd4593435-36a7-4410-9f05-8dffc6a44d7f', 'Cry', '😢', false, 'กิติศักดิ์ แสงทอง'));
    dispatch(togglePostEmoji('588f80c4-2344-421f-8c0e-162b36de1f17', 'd4593435-36a7-4410-9f05-8dffc6a44d7f', 'No', '❌', true, 'กิติศักดิ์ แสงทอง'));
  }
  // แสดง icon ด้าย ซ้าย ชื่อ + เวลา และ content โดย content เยื้องมาจาก icon
  const ContentV2: React.FC<ContentProps> = ({ conv, index }) => {
    // console.log("ContentV2:", conv.postType == null);
    return (
      <div key={index} className="mb-1 ms-1" style={{ display: "flex", alignItems: "flex-start" }}>
        <div className="" style={{ paddingTop: "5px" }} >
          <UserAvatar
            profileImage={conv.pictureUrl ?? ""}
            bgColor={conv.postById === Const.USER_ID_BOT ? "transparent" : (conv.bgColor ?? "")}
            foreColor={conv.postById === Const.USER_ID_BOT ? "red" : (conv.foreColor ?? "")}
            abbrName={conv.postById === Const.USER_ID_BOT ? "🔔" : (conv.abbrName ?? "")}
            size={"xs"}
            includeDivContainer={true}
          />
        </div>
        <div className="" style={{ display: "flex", flexDirection: "column", flex: "1" }}>
          {/* avatar */}
          <div className="">
            <p className={classnames("text-truncate mb-0", { "wp-from-me": conv.isFromMe, "text-danger": conv.postById === Const.USER_ID_BOT })}>
              {/* {index}. */}
              <span m-id={conv.postId} className={classnames({ "wp-unread": !conv.isRead })}>{conv.postByName}</span>
              &nbsp;-&nbsp;
              <span className={classnames("last-chat-text", { "text-danger": conv.postById === Const.USER_ID_BOT })}>{Utils.GetShortDateTimeToShowInChat(conv.postDateTime, false)}</span>
            </p>
          </div>

          <div className={"wp-conver-content" + (instantMode ? "-inst" : "")}>

            {/* post content */}
            <div id={`divWpContent-${conv.postId}`} style={{ flex: "1" }} className={classnames({ "mine": conv.isFromMe })} dangerouslySetInnerHTML={{ __html: formatQuillContent(conv.bodyHtml ?? "") }}>

            </div>

            {/* post command */}
            <div className="wp-post-content-command" style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-end' }}>
              <div>
                <div className="wp-post-resp-ctn" style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <i
                    className="fas fa-ellipsis-v hand text-gray mb-0 wp-post-menu-icon"
                    data-emoji="1"
                    data-show-unsend={(conv.postType == null || conv.postType === WpPostType.None) ? "1" : "0"}
                    data-postid={conv.postId}
                    data-postidparent={conv.postIdParent}
                    data-isfromme={conv.isFromMe}
                    onClick={(e) => onShowRespEmojiPlate(e.currentTarget)}
                  // style={{position:"absolute", left:"28px", width:"20px", textAlign:"center"}}
                  // onMouseOver={(e) => onShowRespEmojiPlate(e.currentTarget)}
                  >
                  </i>
                  {(conv.emojis ?? []).filter(e => e.mbr).map((em: WpEmoji, index2: number) => (
                    <span
                      key={conv.postId + em.nm + index2} className="wp-post-resp-emoji hand hover"
                      onClick={(e) => onClickRespEmojiToggle(conv.postId, conv.postIdParent, em.nm, em.ji)}
                    >{em.ji}{em.mbr.replaceAll(Const.EMOJI_MEMBER_SPLITTER, ", ")}</span>
                  ))}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: "5px" }} >
                <i className="far fa-copy hand wp-eye-who-read mb-1" onClick={() => onCopyPostConent(conv.postId)} ></i>
                <i className="fas fa-eye hand wp-eye-who-read mb-1" onClick={() => viewPostMember(conv.postId)} ></i>
              </div>
            </div>
          </div>


        </div>
      </div >
    );
  }

  const ContentUnsend: React.FC<ContentProps> = ({ conv, index }) => {
    return (
      <div key={index} className="workplace-post-unsend" style={{ /*display: "flex", alignItems: "flex-start"*/ }}>
        -- {conv.postByName} ยกเลิกข้อความ --
      </div>
    )
  }

  const ContentSubscribe: React.FC<ContentProps> = ({ conv, index }) => {
    let info = {};
    try { info = JSON.parse(conv.postTypeInfo ?? "") } catch (e) { }
    const isSub = conv.postType == WpPostType.Subscribe;
    const icon = isSub ? "fas fa-sign-in-alt text-success me-2 fz-10" : "	fas fa-running text-danger ms-2 fz-12";
    return (
      <div key={index} className={"workplace-post-subscribe "} style={{ /*display: "flex", alignItems: "flex-start"*/ }}>
        {isSub && (<span className={icon}></span>)}
        <span className="a-tag me-2">{conv.postByName}</span>
        {isSub ? (<><span className="text-success">เข้าร่วม (subscribe)</span> โพส</>) : (<><span className="text-danger">ออก (un-subscribe)</span> จากโพส</>)}
        {!isSub && (<span className={icon}></span>)}
      </div>
    )
  }

  const ContentRemoveTag: React.FC<ContentProps> = ({ conv, index }) => {
    return (
      <div key={index} className="workplace-post-unsend" style={{ /*display: "flex", alignItems: "flex-start"*/ }}>
        -- {conv.bodyHtml} --
      </div>
    )
  }


  const ContentChangeStatus: React.FC<ContentProps> = ({ conv, index }) => {
    const isClose = (Utils.ToNumber(conv.postTypeInfo, -1) == WpStatus.Close);
    return (
      <div key={index} className="workplace-post-status" style={{ /*display: "flex", alignItems: "flex-start"*/ }}>
        --&nbsp;
        {conv.postByName}
        {(isClose) && (<i className="fas fa-check-circle text-danger ms-2"></i>)}
        {(!isClose) && (<i className="fas fa-upload text-success ms-2"></i>)}
        &nbsp;
        <span className={classnames({ "text-danger": isClose, "text-blue": !isClose })}>
          {Utils.GetWpStatus(Utils.ToNumber(conv.postTypeInfo, WpStatus.Open) as WpStatus)}โพส
        </span>
        &nbsp;เมื่อ {Utils.GetDMYHHMM(conv.postDateTime)}
        &nbsp;--
        {conv.bodyHtml && (
          <>
            <br />เหตุผล: <span dangerouslySetInnerHTML={{ __html: conv.bodyHtml ?? "" }} className={isClose ? "text-danger" : "text-success"}></span>
          </>
        )}
      </div>
    )
  }


  const ContentDSignLog: React.FC<ContentProps> = ({ conv, index }) => {
    return (
      <div key={index} className="workplace-post-dsignlog">
        <div className="workplace-post-dsignlog-datetime">{Utils.GetDMYHHMM(conv.postDateTime)}</div>
        <div dangerouslySetInnerHTML={{ __html: conv.bodyHtml ?? "" }}></div>
      </div>
    )
  }


  const CONVER_SCROLL_TOP_THRESHOLD = 60;

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    //const target: any = event.target;
    showBackButton();
    onScrollTryLoadMoreConver();
  };

  const onScrollTryLoadMoreConver = () => {
    try {
      if (isPrependingConverRef.current || converLoadingMore || !converHasMore || !activePostId || convers.length === 0) return;
      const scrollableNode = refScroll.current?.getScrollElement();
      if (!scrollableNode || scrollableNode.scrollTop > CONVER_SCROLL_TOP_THRESHOLD) return;
      const oldest = convers[0];
      if (!oldest?.postDateTime || !oldest?.postId) return;
      isPrependingConverRef.current = true;
      prevScrollHeightRef.current = scrollableNode.scrollHeight;
      dispatch(loadMorePostConver(wpMode, activePostId, oldest.postDateTime, oldest.postId));
    } catch (e) {
      isPrependingConverRef.current = false;
      Utils.HandleException(e, false);
    }
  }

  const showBackButton = async () => {
    try {
      const scrollableNode = refScroll.current?.getScrollElement();
      // console.log({ scrollHeight, scrollTop, clientHeight });
      const backButton = document.getElementById("back-button-wp") as HTMLButtonElement | null;
      if (backButton) {
        const isNotAtBottom = scrollableNode.scrollHeight - scrollableNode.scrollTop > scrollableNode.clientHeight + 2;
        //console.log({ a: scrollableNode.scrollHeight - scrollableNode.scrollTop, b: scrollableNode.clientHeight + 2 });
        if (isNotAtBottom) {
          backButton.classList.add("show");
        } else {
          backButton.classList.remove("show");
          setHaveNewText(null);
        }
      }
    } catch (e) {
      Utils.HandleException(e, false);
    }
  }

  const onGoBottom = async () => {
    try {
      // refScroll.current.scrollTop = refScroll.current?.scrollHeight;
      const scrollableNode = refScroll.current?.getScrollElement();
      scrollableNode.scrollTo({
        top: scrollableNode.scrollHeight,
        behavior: 'smooth'
      });
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }
  const onTagClick = async (tagId: number) => {
    Utils.ShowWpTagInfo(tagId);
  }
  const onTagClickOld = async (tagId: number) => {
    try {
      const api = new APIClient();
      if (tagId == -1) {
        alert('Invalid tag id');
      } else {
        api.fnPostForm(urls.WP_LOAD_TAG_INFO, { tagId: tagId })
          .then(rs => {
            // console.log('tag info:', rs);
            if (rs.length > 0) {
              let ar: string[] = [];
              let title = '';
              rs.forEach((el: any, index: number) => {
                if (index == 0) {
                  title = `Tag <span class="text-primary">${el.catName} @${el.name}</span>`;
                  if (el.category == Const.WP_CAT_CUS) {
                    const erpUrl = Const.ERP_CUSTOMER_PAGE.replaceAll('[CustomerId]', el.tagKeyId);
                    title += `&nbsp;<a href="${erpUrl}" target="erp_cus_info_${el.tagKeyId}"><span class="badge badge-soft-primary rounded p-1 ml-1 bg-primary hand">ลูกค้ารายตัว</span></a>`;
                  }
                }
                if (el.memberCat) {
                  ar.push(`<tr><td>${el.memberCat}</td><td align="left"><i class="${el.memberIcon}"></i>&nbsp;${el.memberName}</td><td align="center">${el.memberRole}</td></tr>`);
                }
              });
              if (ar.length > 0) {
                alert(title + '<table width="100%">' + ar.join('') + '</table>');
              } else {
                alert(title + '<br/>ไม่มีสมาชิกใน tag');
              }

            } else {
              alert('Not found information of tag selected');
            }
          })
          .catch(e2 => Utils.HandleException(e2, true))
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onClickRespEmojiToggle = async (postId: string, postIdParent: string, emojiName: string, emojiSymbol: string) => {
    try {
      const api = new APIClient();
      const parm = {
        postId: postId,
        postIdParent: postIdParent,
        fromDeviceId: Utils.GetDeviceId(),
        emojiName: emojiName,
        emojiSymbol: emojiSymbol
      };
      setIsEmojiRespShow(false);
      api.fnPostForm(urls.WP_SET_RESP_EMOJI, parm)
        .then(rs => { })
        .catch(e2 => Utils.HandleException(e2, true));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onClickRespEmoji = async (emoji: any) => {
    try {
      onClickRespEmojiToggle(toolPostInfo.postId, toolPostInfo.postIdParent, emoji.name, emoji.icon);
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const [unSendPostProcessing, setUnSendPostProcessing] = useState<boolean>(false);
  const onUnSendPost = async () => {
    try {
      setUnSendPostProcessing(true);
      const api = new APIClient();
      api.fnPostForm(urls.WP_UPDATE_UNSEND, {
        fromDeviceId: Utils.GetDeviceId(),
        postId: toolPostInfo.postId
      })
        .then(rs => {
          setIsEmojiRespShow(false);
          setUnSendPostProcessing(false);
        })
        .catch(e2 => { setIsEmojiRespShow(false); Utils.HandleException(e2, true); setUnSendPostProcessing(false); });

    } catch (e) {
      Utils.HandleException(e, true);
      setUnSendPostProcessing(false);
    }
  }

  useEffect(() => {
    // console.log('toolPostInfo:', toolPostInfo);
    if (isEmojiRespShow) {
      const mnuUnsendPost = document.getElementById('mnuUnsendPost');
      if (mnuUnsendPost) mnuUnsendPost.style.display = toolPostInfo.isFromMe ? "block" : "none";
    }
  }, [isEmojiRespShow, toolPostInfo]);

  const heightHeader = 70;
  //const heightBottom = activePostStatus === WpStatus.Open ? 140 : 0;
  const heightBottom = activePostStatus === WpStatus.Open ? 150 : 0; // 20270702 adjust little gap for able to display in mobile more clear


  const [snoozeDateTime, setSnoozeDateTime] = useState<any>(null);
  const snoozeRef = useRef<HTMLDivElement | null>(null);
  const [isSnoozeOpen, setIsSnoozeOpen] = useState<boolean>(false);
  const [isSnoozeLoading, setIsSnoozeLoading] = useState<boolean>(false);
  const [snoozeErr, setSnoozeErr] = useState<string>("");
  const showTaskStatusMenuRef = useRef<HTMLDivElement | null>(null);
  const showPlanFinishedDateRef = useRef<HTMLDivElement | null>(null);
  const showPostContextMenuRef = useRef<HTMLDivElement | null>(null);

  const onSnoozeClick = (sender: any, postId: string) => {
    const isOpen = !isSnoozeOpen;
    setIsSnoozeOpen(isOpen);
    if (isOpen) {
      setIsSnoozeLoading(true);
      const api = new APIClient();
      api.fnPostForm(urls.WP_POST_SNOOZE_LOAD, { postId: postId })
        .then(rs => {
          setIsSnoozeLoading(false);
          const date = new Date(rs.snoozeDateTime);
          // console.log([date, rs.snoozeDateTime]);
          setSnoozeDateTime(date);
          // console.log(rs);
        })
        .catch(err => {
          setIsSnoozeLoading(false);
          Utils.HandleException(err, true);
        });
    }
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      // console.log('target:', target);
      const clickedInsideSnooze = snoozeRef.current?.contains(target);
      const clickedInsideCalendar = (target as HTMLElement).closest('.react-datepicker') !== null || (target as HTMLElement).closest('.wp-ddl-snooze-calendar') !== null;
      if (!clickedInsideSnooze && !clickedInsideCalendar) {
        setIsSnoozeOpen(false);
      }
    };

    if (isSnoozeOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSnoozeOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      const clickedInside = showTaskStatusMenuRef.current?.contains(target) || showPlanFinishedDateRef.current?.contains(target);
      // const clickedInsideCalendar = (target as HTMLElement).closest('.react-datepicker') !== null || (target as HTMLElement).closest('.wp-ddl-snooze-calendar') !== null;
      if (!clickedInside) {
        setShowTaskStatusMenu(false);
        setShowPlanFinishedDate(false);
      }
    };

    if (showTaskStatusMenu || showPlanFinishedDate) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTaskStatusMenu, showPlanFinishedDate]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      const clickedInside = showPostContextMenuRef.current?.contains(target);
      // const clickedInsideCalendar = (target as HTMLElement).closest('.react-datepicker') !== null || (target as HTMLElement).closest('.wp-ddl-snooze-calendar') !== null;
      if (!clickedInside) {
        setShowPostContextMenu(false);
      }
    };

    if (showPostContextMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPostContextMenu]);

  const applySnoozeDate = (isAdd: boolean) => {
    try {
      if (isAdd) {
        setSnoozeErr('');
        if (!snoozeDateTime) {
          setSnoozeErr('กรุณาระบุวันเวลาที่จะแจ้งเตือน');
          return;
        }
        // console.log([snoozeDateTime, snoozeDateTime.toISOString()]);
        // return;
        const now = new Date();
        const diffMs = snoozeDateTime.getTime() - now.getTime();
        const diffMinutes = diffMs / 1000 / 60;
        if (diffMinutes < 10) {
          setSnoozeErr('กรุณาตั้งเวลาอย่างน้อย 10 นาที');
          return;
        }
      }
      const api = new APIClient();
      setIsSnoozeLoading(true);
      const postId = activePostId ?? "";
      const parm = {
        postId: postId,
        snoozeDateTime: Utils.ToLocalDateString(snoozeDateTime),
        isSave: isAdd
      };
      // console.log('parm:', parm);
      api.fnPostForm(urls.WP_POST_SNOOZE_SAVE, parm)
        .then(rs => {
          // console.log('rs:', rs);
          dispatch(setSnooze(wpMode, postId, rs.snooze));
          setIsSnoozeLoading(false);
          setIsSnoozeOpen(false);
        })
        .catch(e2 => {
          setIsSnoozeLoading(false);
          setSnoozeErr(Utils.GetMessageFromExecption(e2));
        });
    } catch (e1) {
      setIsSnoozeLoading(false);
      setSnoozeErr(Utils.GetMessageFromExecption(e1));
    }
  }


  const addSnoozeDate = (increase: number, unit: "second" | "minute" | "hour" | "day") => {
    setSnoozeDateTime(Utils.DateAdd(new Date(), increase, unit));
  }

  const addSnoozeDate2 = (mode: "Today 1PM" | "Tomorrow 8AM" | "Tomorrow 1PM" | "Next Monday 8AM" | "1st Next Month") => {
    const now = new Date();
    let newDate = new Date();

    // Utility function to clone and set time
    const setTime = (baseDate: Date, hour: number, minute: number): Date => {
      const d = new Date(baseDate);
      d.setHours(hour, minute, 0, 0);
      return d;
    };

    switch (mode) {
      case "Today 1PM": {
        const todayAt1PM = setTime(now, 13, 0);
        // If it's already past 1PM today, move to tomorrow
        // if (todayAt1PM <= now) {
        //   todayAt1PM.setDate(todayAt1PM.getDate() + 1);
        // }
        newDate = todayAt1PM;
        break;
      }

      case "Tomorrow 8AM": {
        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
        newDate = setTime(tomorrow, 8, 0);
        break;
      }

      case "Tomorrow 1PM": {
        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
        newDate = setTime(tomorrow, 13, 0);
        break;
      }

      case "Next Monday 8AM": {
        const result = new Date(now);
        const day = result.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
        const daysUntilNextMonday = (8 - day) % 7 || 7; // Ensure it's at least 1 day ahead
        result.setDate(result.getDate() + daysUntilNextMonday);
        newDate = setTime(result, 8, 0);
        break;
      }

      case "1st Next Month": {
        const result = new Date(now);
        result.setMonth(result.getMonth() + 1);
        result.setDate(1);
        newDate = setTime(result, 8, 0); // Optional time, e.g., 8AM
        break;
      }

      default:
        throw new Error(`Unsupported mode: ${mode}`);
    }
    if (newDate > new Date()) {
      setSnoozeDateTime(newDate);
    }
  }
  const isPass1PM = new Date().getHours() >= 13;

  interface CustomInputProps {
    value?: string;
    onClick?: () => void;
  }

  const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
    ({ value, onClick }, ref) => (
      <input
        ref={ref}
        value={value}
        readOnly
        onClick={onClick}
        placeholder="Select date"
        style={{ cursor: "pointer", /*border:"solid 1px red"*/ }}
      />
    )
  );

  const onPreviewImage = (idImage: string) => {
    try {
      const redirect = `/wpcol/${activePostIdRef.current}/${idImage}`;
      if (Utils.IsDesktop()) {
        const w = 1200, h = 800;
        const left = Math.max(0, (window.screen.width - w) / 2);
        const top = Math.max(0, (window.screen.height - h) / 2);
        window.open(redirect, 'wpImagePreview', `width=${w},height=${h},top=${top},left=${left},resizable=yes,scrollbars=yes`);
      } else {
        setPreviewImage({ postIdParent: activePostIdRef.current, selImageId: idImage });
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const [previewImage, setPreviewImage] = useState<any>(null)
  const [excelPreviewUrl, setExcelPreviewUrl] = useState<string | null>(null)
  const [isChangingTaskStatus, setIsChangingTaskStatus] = useState<boolean>(false);

  const onChangeStatusAndPlanFinishedDate = async (taskStatus: TaskStatus | null, planFinishdDate: Date | null, remark: string | null = null) => {
    try {
      setShowTaskStatusMenu(false);
      setShowPlanFinishedDate(false);
      setTaskStatusRemarkError(null);
      setIsChangingTaskStatus(true);
      const parm = {
        postIdTop: activePostIdRef.current,
        deviceId: Utils.GetDeviceId(),
        taskStatus: taskStatus,
        planFinishdDate: planFinishdDate,
        remark: remark,
      }
      new APIClient().fnPostForm(urls.WP_SAVE_POST_INFO_CHANGE_TASK_STATUS2_V1, parm)
        .then(rs => {
          console.log('rs:', rs);
          setIsChangingTaskStatus(false);
        })
        .catch(e2 => {
          setIsChangingTaskStatus(false);
          Utils.HandleException(e2, true);
        })
    } catch (e) {
      setIsChangingTaskStatus(false);
      Utils.HandleException(e, true);
    }

  }

  // Statuses that must not be applied without the user typing a reason.
  const isTaskStatusRemarkRequired = (status: TaskStatus | null) => status === TaskStatus.Hold || status === TaskStatus.Cancel;

  const onChangeTaskStatus = async (newStatus: TaskStatus) => {
    setShowTaskStatusMenu(false);
    setTaskStatusRemarkError(null);
    setTaskUpdateState({
      taskStatus: newStatus,
      planFinishedDate: newStatus == TaskStatus.OnGoing ? (activePostPlanFinishedDate ?? null) : null,
      remark: "",
      isDateOnly: false,
    });
    setShowPlanFinishedDate(true);
  }

  const onConfirmTaskStatusChange = () => {
    if (!taskUpdateState) return;
    if ((taskUpdateState.taskStatus == TaskStatus.OnGoing || taskUpdateState.isDateOnly) && !taskUpdateState.planFinishedDate) {
      setTaskStatusRemarkError("กรุณาระบุวันกำหนดเสร็จ");
      return;
    }
    if (!taskUpdateState.isDateOnly && isTaskStatusRemarkRequired(taskUpdateState.taskStatus) && !taskUpdateState.remark.trim()) {
      setTaskStatusRemarkError("กรุณาระบุหมายเหตุ");
      return;
    }
    onChangeStatusAndPlanFinishedDate(taskUpdateState.taskStatus, taskUpdateState.planFinishedDate, taskUpdateState.remark.trim() || null);
  }

  const onTaskStatusClick = () => {
    setShowTaskStatusMenu(prev => !prev);
  }

  const onTaskDateClick = (date: Date | null) => {
    setTaskStatusRemarkError(null);
    setTaskUpdateState({ taskStatus: null, planFinishedDate: date, remark: "", isDateOnly: true });
    setShowPlanFinishedDate(prev => !prev);
  }

  const onPostCommandClick = (sender: any, cmd: PostCommands, postId: string) => {
    // console.log('setShowPostContextMenu(false);');
    setShowPostContextMenu(false);
    if (cmd == PostCommands.Snooze) {
      onSnoozeClick(sender, postId);
    }
  }

  const onContextMenuClick = () => {
    // console.log('onContextMenuClick');
    setShowPostContextMenu(prev => !prev);
  }

  const [showJoin, setShowJoin] = useState(false);

  useEffect(() => {
    if (activePostStatus === WpStatus.Open && !activePostYouIsMember) {
      const timer = setTimeout(() => {
        setShowJoin(true);
      }, 300);

      return () => clearTimeout(timer);
    } else {
      setShowJoin(false);
    }
  }, [activePostStatus, activePostYouIsMember]);

  const [isSubcribing, setIsSubcribing] = useState<boolean>(false);
  const onSubscribe = async () => {
    await Utils.ToggleSubscribe(activePostId ?? "", dispatch, (loading) => { setIsSubcribing(loading) });
  }

  const showQuillInput = activePostInfoLoading || (activePostStatus === WpStatus.Open && activePostYouIsMember); // show immedaitely
  // console.log('xxx:', { activePostInfoLoading, activePostStatus, activePostYouIsMember, showQuillInput });
  //const showQuillInput = !activePostInfoLoading && (activePostStatus === WpStatus.Open && activePostYouIsMember); // show when check member done

  const isModeMismatch = !activePostInfoLoading && !!activePostId && activePostMode != null && activePostMode !== wpMode;

  const isSmallScreen = viewPortWidth <= 768;

  const onBack = () => {
    dispatch(setActivePostId2(wpMode, null, null, null, null, null, "Click back from post"));
    dispatch(changeSelectedChat(null));
  }

  // 20260721 make the Android/PWA system back button close the open post/task
  // (same as the mobile back button) instead of navigating away from the app
  useBackButtonClose(isSmallScreen && activePostId != null, onBack);

  const showPlanFinishedDateLeft = isSmallScreen ? 0 : 75;

  return (
    <>
      {previewImage && <WorkplaceCollectionModal postIdParent={previewImage.postIdParent} selImageId={previewImage.selImageId} onToggle={() => setPreviewImage(null)}></WorkplaceCollectionModal>}
      {excelPreviewUrl && <ExcelPreviewModal url={excelPreviewUrl} onClose={() => setExcelPreviewUrl(null)} />}

      <div id="workplace-container" className="workplace-container">
        {isSnoozeOpen && (
          <div className="wp-ddl-snooze" ref={snoozeRef}>
            <div className="d-flex justify-content-start align-items-center">
              <i className={classnames("hand material-icons fz-13 text-danger")}>snooze</i>ตั้งเตือนโพส
              {isSnoozeLoading && (<LoadingIconWithText loadingText={""} />)}
            </div>
            <div className="d-flex flex-wrap" style={{ gap: "3px" }}>
              {/* <span className="wp-tag-filter hand hover" onClick={() => addSnoozeDate(30, "minute")}>อีก 30 นาที</span>
            <span className="wp-tag-filter hand hover" onClick={() => addSnoozeDate(2, "hour")}>อีก 2 ชั่วโมง</span>
            <span className="wp-tag-filter hand hover" onClick={() => addSnoozeDate(1, "day")}>อีก 1 วัน</span>
            <span className="wp-tag-filter hand hover" onClick={() => addSnoozeDate(3, "day")}>อีก 3 วัน</span>
            <span className="wp-tag-filter hand hover" onClick={() => addSnoozeDate(7, "day")}>อีก 1 อาทิตย์</span> */}

              <span className={classnames("wp-tag-filter hand hover", { "disabled": isPass1PM })} onClick={() => addSnoozeDate2("Today 1PM")}>วันนี้ 1PM</span>
              <span className={classnames("wp-tag-filter hand hover")} onClick={() => addSnoozeDate2("Tomorrow 8AM")}>พรุ่งนี้ 8AM</span>
              <span className={classnames("wp-tag-filter hand hover")} onClick={() => addSnoozeDate2("Tomorrow 1PM")}>พรุ่งนี้ 1PM</span>
              <span className={classnames("wp-tag-filter hand hover")} onClick={() => addSnoozeDate2("Next Monday 8AM")}>จันทร์หน้า 8AM</span>
              <span className={classnames("wp-tag-filter hand hover")} onClick={() => addSnoozeDate2("1st Next Month")}>วันที่ 1 เดือนหน้า</span>

            </div>
            <DatePicker
              selected={snoozeDateTime}
              onChange={(date: any) => setSnoozeDateTime(date)}
              dateFormat={"dd/MM/yyyy HH:mm"} isClearable portalId="root-portal"
              className="form-control p-1"
              showTimeSelect={true}
              minDate={new Date()}
              popperPlacement="bottom-end"
              popperClassName="wp-ddl-snooze-calendar"
              customInput={<CustomInput />}
              calendarStartDay={1}
            ></DatePicker>
            <div className="d-flex justify-content-end align-items-center" style={{ gap: "5px" }}>
              <button className="flex-fill fz-09 btn btn-sm btn-danger" onClick={(e) => applySnoozeDate(false)}>ลบ</button>
              <button className="flex-fill fz-09 btn btn-sm btn-warning" onClick={(e) => setIsSnoozeOpen(false)}>ยกเลิก</button>
              <button className="flex-fill fz-09 btn btn-sm btn-primary" onClick={(e) => applySnoozeDate(true)}>ตกลง</button>
            </div>
            {snoozeErr && (<div className="d-flex justify-content-end align-items-center text-danger" style={{ overflow: "auto" }}>{snoozeErr}</div>)}
          </div>
        )}

        {/* header */}
        <div className="p-3 p-md-2 workplace-header" style={{ pointerEvents: isModeMismatch ? "none" : undefined }}>
          <WorkplaceHead onOpenPostDetails={() => { }} onTagClick={onTagClick} onSnoozeClick={onSnoozeClick} wpMode={wpMode} onTaskStatusClick={onTaskStatusClick} onContextMenuClick={onContextMenuClick} onTaskDateClick={onTaskDateClick} />
        </div>

        {showPostContextMenu && !isModeMismatch && (
          <div ref={showPostContextMenuRef}>
            <PostCommand showAsDropdown={true} wpMode={wpMode} onCommandClick={onPostCommandClick} />
          </div>
        )}

        {showTaskStatusMenu && (
          <div ref={showTaskStatusMenuRef} className="context_menu_base" style={{ top: "70px", left: "55px", minWidth: "150px" }}>
            {Utils.GetTaskStatusForShow().map((sts, index) => (
              <div
                key={index}
                className={"hand hover mb-1 mt-1 " + (taskStatus == sts ? " selected " : "")}
                onClick={() => taskStatus == sts ? null : onChangeTaskStatus(sts)}
              >
                {Utils.GetTaskStatusIcon(sts)}{Utils.GetTaskStatusText(sts)}
              </div>
            ))}
          </div>
        )}

        {showPlanFinishedDate && (
          <div ref={showPlanFinishedDateRef} className="context_menu_base" style={{ top: "70px", left: showPlanFinishedDateLeft, minWidth: "300px" }}>
            <div className="dialog-header">{(taskUpdateState?.taskStatus == TaskStatus.OnGoing || taskUpdateState?.isDateOnly) ? "ระบุวันกำหนดเสร็จ" : "เปลี่ยนสถานะงาน"}</div>
            {(taskUpdateState?.taskStatus == TaskStatus.OnGoing || taskUpdateState?.isDateOnly) && (
              <Calendar value={taskUpdateState?.planFinishedDate} onChange={(value) => setTaskUpdateState(prev => prev ? { ...prev, planFinishedDate: value as Date } : prev)} />
            )}
            {!taskUpdateState?.isDateOnly && (
              <textarea
                className="form-control mt-2"
                rows={2}
                placeholder={isTaskStatusRemarkRequired(taskUpdateState?.taskStatus ?? null) ? "หมายเหตุ (จำเป็นต้องระบุ)" : "หมายเหตุ (ไม่จำเป็น)"}
                value={taskUpdateState?.remark ?? ""}
                onChange={(e) => setTaskUpdateState(prev => prev ? { ...prev, remark: e.target.value } : prev)}
              />
            )}
            {taskStatusRemarkError && (<div className="text-danger fz-12 mt-1">{taskStatusRemarkError}</div>)}
            <div className="d-flex justify-content-end mt-2" style={{ gap: "5px" }}>
              <button className="btn btn-sm btn-secondary" onClick={() => { setShowPlanFinishedDate(false); setTaskStatusRemarkError(null); }}>ยกเลิก</button>
              <button className="btn btn-sm btn-primary" onClick={onConfirmTaskStatusChange}>ตกลง</button>
            </div>
          </div>
        )}

        {/* emoji resp */}
        {isEmojiRespShow && (
          <div ref={popupRef} className="workplae-post-tool" style={{ left: emojiRespPos.left, top: emojiRespPos.top }}>
            {/* emoji plate */}
            <div className="row">
              {emojis.map((emoji, index) => (
                <React.Fragment key={index}>
                  <div
                    // key={index}
                    className="col text-center workplae-emoji-tool-each hover"
                    onClick={() => onClickRespEmoji(emoji)}
                    style={{ cursor: 'pointer', fontSize: '1.5rem'/*, margin: '5px 0', width: "30px", height: "30px"*/ }}
                    title={emoji.name}
                  >
                    {emoji.icon}
                  </div>
                  {(index + 1) % 4 == 0 && (<div className="w-100"></div>)}
                </React.Fragment>
              ))}
            </div>
            <div className="row">
              <div className="col">
                <hr className="w-100" style={{ marginTop: "5px", marginBottom: "5px" }} />
              </div>
            </div>
            {showUnsendMenu && (
              <div id="mnuUnsendPost" className="row">
                {unSendPostProcessing && (<div className="col" style={{ fontSize: "1.0rem" }}><LoadingIconWithText loadingText={"กำลังยกเลิก"} /></div>)}
                {!unSendPostProcessing && (
                  <div className="col hover hand" style={{ fontSize: "1.0rem" }} onClick={() => onUnSendPost()}>
                    <i className="fa fa-undo"></i>&nbsp;ยกเลิกข้อความ
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* content */}
        {isChangingTaskStatus && (<Loader />)}
        {converErrMsg && (
          <div className="d-flex flex-column align-items-center justify-content-center text-danger p-3" style={{ gap: "8px" }}>
            <div>{converErrMsg}</div>
            <button className="btn btn-sm btn-outline-danger" onClick={onRetryLoadConver}>ลองใหม่</button>
          </div>
        )}
        {/* <AppSimpleBar className="workplace-chat debug-border-2" scrollRef={refScroll} onScrollCapture={handleScroll} style={{ height: `calc(100vh - ${heightHeader}px - ${heightBottom}px)` }}> */}
        {!converErrMsg && (
        <div className="workplace-chat" style={{ position: "relative" }}>
          {converLoading && (
            <span
              className="d-inline-block rounded-circle bg-danger"
              style={{ width: "6px", height: "6px", position: "absolute", top: "4px", right: "8px", zIndex: 1 }}
              title="กำลังอัพเดทข้อความ"
            ></span>
          )}
          <AppSimpleBar scrollRef={refScroll} onScrollCapture={handleScroll} style={{ height: "100%", maxHeight: "100%" }} >
            {/* use div seem better performance than UL */}
            <div id="divConverContainer" className="px-3 pb-3 p-md-2" style={{ display: "flex", flexDirection: "column" }}>
              {convers.map((conv: WpConver, key: number) => (
                // <div key={key} className="wp-conver mb-3" ref={key === convers.length - 1 ? lastMessageRef : null} >
                <div key={key} className="wp-conver mb-3">
                  {conv.isUnsend ? (
                    <ContentUnsend conv={conv} index={key} />
                  ) : (conv.postType == WpPostType.Subscribe || conv.postType == WpPostType.UnSubscribe) ? (
                    <ContentSubscribe conv={conv} index={key} />
                  ) : conv.postType == WpPostType.ChangeStatus ? (
                    <ContentChangeStatus conv={conv} index={key} />
                  ) : conv.postType == WpPostType.RemoveTag ? (
                    <ContentRemoveTag conv={conv} index={key} />
                  ) : conv.postType == WpPostType.DSignLog ? (
                    <ContentDSignLog conv={conv} index={key} />
                  ) : conv.postType == WpPostType.ChangePostInfo ? (
                    <ContentV2 conv={conv} index={key} />
                  ) : (
                    <ContentV2 conv={conv} index={key} />
                  )}
                  {/* <ContentV2 conv={conv} index={key} /> */}
                </div>
              ))}
            </div>
          </AppSimpleBar>
        </div>
        )}
        {haveNewText && (
          <span id="spnNewText" className='span-new-post-text hand text-red' onClick={onGoBottom} >
            <i className="fas fa-angle-down"></i>&nbsp;ข้อความใหม่จาก {haveNewText}&nbsp;<i className="fas fa-angle-down"></i>
          </span>
        )}
        <i id="back-button-wp" className='back-button-wp bx bx-down-arrow-circle hand' onClick={onGoBottom} ></i>

        {isModeMismatch ? (
          <div className="p-3 p-md-2 workplace-input debug-border-1">
            <div className="text-warning text-center">
              <i className="fas fa-exclamation-triangle me-1"></i>
              {wpMode === WpModes.Workplace ? "โพสถูกย้าย หรือลบไปแล้ว" : "งานถูกลบไปแล้ว"}
            </div>
          </div>
        ) : showQuillInput ? (
          <div className="p-3 p-md-2 workplace-input" style={{ height: inputPanelHeight }}>
            <WorkplaceQuill
              wpMode={wpMode}
              editorMinHeight={inputEditorHeight}
              editorMaxHeight={inputEditorHeight}
              isLargeStage={isLageEditor}
              onLargeStageClick={onLargeStageClick}
              instantMode={instantMode}
            />
          </div>
        ) : (!activePostInfoLoading && showJoin) ? (
          <div className="p-3 p-md-2 workplace-input debug-border-1">
            <button className="btn btn-outline-primary w-100" onClick={(e) => isSubcribing ? null : onSubscribe()}>
              {isSubcribing && (<><LoadingIconWithText loadingText={""} />&nbsp;กำลังเข้าร่วม</>)}
              {!isSubcribing && (<>เข้าร่วม</>)}
            </button>
          </div>
        ) : (
          <></>
        )}

        {(!showQuillInput && isSmallScreen) && (
          <button className="btn btn-warning btn-post-back" onClick={onBack}><i className="fas fa-chevron-circle-left me-1"></i>Back</button>
        )}

      </div>
    </>
  );
};

export default WorkplaceContent;
